// extracted by mini-css-extract-plugin
export var highlightFade = "_37-4";
export var highlighted = "_37-3";
export var table = "_37-1";
export var tableContainer = "_37-0";
export var totalsRow = "_37-2";